import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../images/avatar.jpeg';
import _imports_1 from '../../../images/chuang.png';
import _imports_2 from '../../../images/av.jpeg';
import _imports_3 from '../../../images/play.png';
import _imports_4 from '../../../images/like.png';
import _imports_5 from '../../../images/comment.png';
import _imports_6 from '../../../images/share.png';

const _withScopeId = n => (_pushScopeId("data-v-54cd4a7c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "featured-avItem"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"thin-line\" data-v-54cd4a7c></div><div class=\"featured-avItem-header\" data-v-54cd4a7c><div class=\"featured-avItem-avatar\" data-v-54cd4a7c><img src=\"" + _imports_0 + "\" alt=\"\" srcset=\"\" data-v-54cd4a7c><img class=\"chuang\" src=\"" + _imports_1 + "\" alt=\"\" srcset=\"\" data-v-54cd4a7c></div><div class=\"featured-avItem-name\" data-v-54cd4a7c><p data-v-54cd4a7c>六蜀黍</p><span data-v-54cd4a7c>2021-07-30</span></div></div>", 2);

const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"avItem-linear\" data-v-54cd4a7c></div><div class=\"avItem-cover\" data-v-54cd4a7c><div class=\"box\" data-v-54cd4a7c><img src=\"" + _imports_2 + "\" alt=\"\" srcset=\"\" data-v-54cd4a7c></div></div><div class=\"avItem-layer\" data-v-54cd4a7c><p data-v-54cd4a7c>3/8日本极限另类变态SMの变态公众肉便所【朝桐 光】</p><div data-v-54cd4a7c><span data-v-54cd4a7c>1万次播放</span><span class=\"avItem-time\" data-v-54cd4a7c>13:31</span></div></div>", 3);

const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"featured-avItem-bottom\" data-v-54cd4a7c><div class=\"featured-avItem-bottom-layer\" data-v-54cd4a7c></div><div class=\"avItem-bottom-item\" data-v-54cd4a7c><img src=\"" + _imports_4 + "\" data-v-54cd4a7c><span data-v-54cd4a7c>264</span></div><div class=\"avItem-bottom-item\" data-v-54cd4a7c><img src=\"" + _imports_5 + "\" data-v-54cd4a7c><span data-v-54cd4a7c>264</span></div><div class=\"avItem-bottom-item\" data-v-54cd4a7c><img src=\"" + _imports_6 + "\" data-v-54cd4a7c><span data-v-54cd4a7c>264</span></div></div>", 1);

import { useStore } from "vuex";
export default {
  __name: 'VideoComponent',

  setup(__props) {
    const store = useStore();

    const videoPlay = () => {
      store.commit("SET_LOGIN_POPUP", {
        show: true,
        type: "VideoDetails"
      });
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        class: "featured-avItem-cover"
      }, [_hoisted_4, _createElementVNode("div", {
        class: "avItem-layerCenter"
      }, [_createElementVNode("img", {
        src: _imports_3,
        alt: "",
        srcset: "",
        onClick: videoPlay
      })])]), _hoisted_7]);
    };
  }

};